import React from 'react';

const CardNav = ({ Prev, Next }) => (
  <div className="w-auto flex justify-center md:justify-between items-start flex-wrap mt-8">
    {Prev && <Prev />}
    {Next && <Next />}
  </div>
);

export default CardNav;
